import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import withMemo from '../../decorators/withMemo';
import AboutTemplate from '../../templates/About';
import { useHeader, useFooter } from '../../hooks/useAppLayout';
import { useNavPath } from '../../hooks/useNavPath';
import { Router } from '../../routes';
import routes from '../../routes/definitions';
import { selectors as AuthSelectors } from '../../redux/auth/redux';
import sagas from './sagas';
var About = function About() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var headerProps = useHeader();
  var footerProps = useFooter();
  var navPathProps = useNavPath();
  var isConnected = useSelector(AuthSelectors.isConnected);
  var layoutProps = {
    theme: {
      maxWidth: 640
    }
  };
  var pageTitleProps = {
    text: t('about')
  };
  var paragraphProps = {
    text: t('about_page_introduction')
  };
  var pageActionsProps = {
    actions: [{
      link: isConnected ? Router.getRouteUrl(routes.start) : Router.getRouteUrl(routes.scholarship),
      label: t('apply')
    }]
  };
  var aboutTemplateProps = {
    headerProps: headerProps,
    navPathProps: navPathProps,
    footerProps: footerProps,
    layoutProps: layoutProps,
    pageTitleProps: pageTitleProps,
    paragraphProps: paragraphProps,
    pageActionsProps: pageActionsProps
  };
  return /*#__PURE__*/React.createElement(AboutTemplate, aboutTemplateProps);
};
About.getInitialProps = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(ctx) {
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", ctx.store.saga.run(sagas.init, ctx).toPromise());
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}();
About.propTypes = {};
About.defaultProps = {};
export default withMemo()(About);